<template>
  <div>
    <section-definition :title="page.title"></section-definition>
    <v-container fluid>


      <!--<v-layout wrap>-->
        <!--<v-flex xs6>-->

          <!--<div class="col-3">-->
            <!--<h3>Draggable 1</h3>-->
            <!--<draggable class="list-group" :list="list1" :group="{name: 'g1', pull:true}" >-->
              <!--<div-->
                      <!--class="list-group-item"-->
                      <!--v-for="(element, index) in list1"-->
                      <!--:key="element.name"-->
              <!--&gt;-->
                <!--{{ element.name }}-->
              <!--</div>-->
            <!--</draggable>-->
          <!--</div>-->


          <!--<div class="col-3">-->
            <!--<h3>Draggable 2</h3>-->
            <!--<draggable class="list-group" :list="list3" :group="{name: 'g1', pull:true}" >-->
              <!--<div-->
                      <!--class="list-group-item"-->
                      <!--v-for="(element, index) in list3"-->
                      <!--:key="element.name"-->
              <!--&gt;-->
                <!--{{ element.name }}-->
              <!--</div>-->
            <!--</draggable>-->
          <!--</div>-->



        <!--</v-flex>-->
        <!--<v-flex xs6>-->
          <!--<div class="col-3">-->
            <!--<h3>Draggable 2</h3>-->
            <!--<draggable class="list-group" :list="list2" :group="{name: 'g1', pull:true}" >-->
              <!--<div-->
                      <!--class="list-group-item"-->
                      <!--v-for="(element, index) in list2"-->
                      <!--:key="element.name"-->
              <!--&gt;-->
                <!--{{ element.name }}-->
              <!--</div>-->
            <!--</draggable>-->
          <!--</div>-->

        <!--</v-flex>-->
      <!--</v-layout>-->

      <!---->







      <!--list 1-->
      <!--<draggable-->
              <!--:list="graders2[0].dealerships"-->
              <!--:group="{name: 'G1'}"-->
      <!--&gt;-->
        <!--<div-->
                <!--v-for="subItem in graders2[0].dealerships"-->
                <!--:key="subItem.name2"-->
        <!--&gt;-->
          <!--{{subItem.name2}}-->
        <!--</div>-->

      <!--</draggable>-->


      <!--list 2-->
      <!--<draggable :list="graders2[1].dealerships"-->
                 <!--:group="{name: 'G1'}"-->
                 <!--:dragoverBubble="false"-->
                 <!--style="min-height: 10px;">-->
        <!--<div-->
                <!--v-for="subItem in graders2[1].dealerships"-->
                <!--:key="subItem.name2"-->
        <!--&gt;-->
          <!--{{subItem.name2}}-->
        <!--</div>-->

      <!--</draggable>-->










      <div class="saving-msg" v-bind:class="saving_error_class">
        {{saving_msg}}
      </div>


      <v-layout wrap>
        <!----------------------------list of graders------------------------------------------------------------------>
        <v-flex xs12 sm6 pr-2>
          <v-card>
            <!--<v-toolbar color="accent">-->
            <!--<v-toolbar-side-icon></v-toolbar-side-icon>-->

            <!--<v-toolbar-title>Graders</v-toolbar-title>-->

            <!--<v-spacer></v-spacer>-->

            <!--<v-btn icon>-->
            <!--<v-icon>more_vert</v-icon>-->
            <!--</v-btn>-->
            <!--</v-toolbar>-->

            <v-toolbar color="transparent" flat>
              <v-toolbar-title>Dealership Graders</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="collaps_all">
                <v-icon>unfold_less</v-icon>
              </v-btn>
              <v-btn icon @click="expand_all">
                <v-icon>unfold_more</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text>
              <v-list :expand="true">
                <v-list-group
                        v-for="(item, i) in graders"
                        :key="item.name"
                        :prepend-icon="item.action"
                        no-action
                        :value="item.expanded"
                >
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-list-tile-avatar>
                        <img :src="item.picture">
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>

                  <draggable
                          :list="graders[i].dealerships"
                          :group="{name: 'G1'}"
                          style="min-height: 10px;"
                          v-bind:id="'grader-ix--'+i"
                          @remove="save_data"
                  >

                    <v-list-tile
                            v-for="subItem in graders[i].dealerships"
                            :key="subItem.name2"
                    >
                      <v-list-tile-content>
                        <v-chip>{{ subItem.name2 }}</v-chip>
                      </v-list-tile-content>
                    </v-list-tile>

                  </draggable>


                </v-list-group>
              </v-list>
            </v-card-text>

          </v-card>
        </v-flex>


        <!--------------------------------list of dealers-------------------------------------------------------------->
        <v-flex xs12 sm6 pl-2>
          <v-card>
            <v-toolbar color="transparent" flat>
              <v-toolbar-title>Unassigned Dealerships</v-toolbar-title>
            </v-toolbar>

            <v-card-text style="max-height: 900px; overflow-y: scroll">
              <v-list :expand="true" >
                <draggable
                        :list="dealerships"
                        :group="{name: 'G1'}"
                        @remove="save_data"
                        id="unassigned-dealers"

                >
                  <v-list-tile
                          v-for="Item in dealerships"
                          :key="Item.name2"
                          @click=""
                  >
                    <v-list-tile-content>
                      <!--<v-list-tile-title>{{ // Item.name2 }}</v-list-tile-title>-->
                      <v-chip>{{ Item.name2 }}</v-chip>
                    </v-list-tile-content>

                  </v-list-tile>
                </draggable>

              </v-list>
            </v-card-text>

          </v-card>












        </v-flex>
      </v-layout>





    </v-container>
  </div>
</template>


<style scoped>

  .saving-msg{
    height: 30px;
    padding-bottom: 5px;
    padding-left: 5px;
  }

  .saving-msg-err{
    color: red;
  }
</style>
<script>
   import axios from 'axios';
   import draggable from 'vuedraggable';
   import validate from '../mixins/validation';
   import data_getters from '../mixins/data_getters';



   export default {
      mixins: [data_getters],
      components: {draggable},
      data() {
         return {

            graders: [],
            dealerships: [],

            saving_msg: '',
            saving_error_class: '',

            // list1: [
            //    { name: "Person1", id: 1 },
            //    { name: "Person2", id: 2 },
            //
            // ],
            // list2: [
            //    { name: "Person3", id: 3 },
            //    { name: "Person4", id: 4 },
            //
            // ],
            // list3: [
            //    { name: "Person5", id: 5 },
            //    { name: "Person6", id: 6 },
            //
            // ],

            page: {
               title: "Manage Graders",
            },
         };
      },

      methods:{

         async get_dealers_local(){

            this.dealerships = await this.get_dealers();

            this.dealerships = this.dealerships.map((x)=>{
               x.name2 = x.org_id.name +'/'+ x.name;
               return x;
            });

         },

         async get_graders_local(){

            this.graders = await this.get_users({user_role: 'Grader'});

            this.graders2 = [];
            for (let i=0; i< this.graders.length; i++){
               this.graders[i].dealerships = [];
               this.graders[i].expanded = true;
            }

            //note this line is necessary or vue.draggable/sortable won't work correctly for the nested sub lists
            // best I can tell there's some issue with object references/vue's reactive system
            this.graders = JSON.parse(JSON.stringify(this.graders));
         },

         async update_data(){

            let data = await Promise.all([this.get_dealers(), this.get_users({user_role: 'Grader', is_active:true}),
                                          this.get_users({user_role: 'AcctManager', is_active:true})  ]);

            let dealers = data[0];
            let graders = data[1].concat(data[2]);

            graders.sort((a, b) => (a.name > b.name) ? 1 : -1);

            let graders_ix = {}; //hash table mapping user_id's to index position

            dealers = dealers.map((x)=>{
               x.name2 = x.org_id.name +'/'+ x.name;
               return x;
            });


            // add dealership list to each grader object
            for (let i=0; i< graders.length; i++){
               graders[i].dealerships = [];
               graders[i].expanded = true;
               graders_ix[graders[i].user_id] = i;
            }

            //go through dealership list and add dealerships to appropriate grader list
            let k=0, n = dealers.length;
            for (let i=0; i<n; i++){
               if (dealers[k].grader_id !== null){
                  let tmp = dealers.splice(k, 1)[0];
                  // console.log(graders_ix);
                  // console.log(tmp);

                  let ix = graders_ix[tmp.grader_id] ;
                  console.log(tmp.grader_id, ix);


                  if (ix !== undefined){
                     graders[ix].dealerships.push(tmp);
                  }

               }
               else{
                  k += 1;
               }

            }//for i

            //note this line is necessary or vue.draggable/sortable won't work correctly for the nested sub lists
            // best I can tell there's some issue with object references/vue's reactive system
            this.graders = JSON.parse(JSON.stringify(graders));
            this.dealerships = dealers;


         },

         collaps_all(){
            for (let i=0; i<this.graders.length; i++){
               this.graders[i].expanded = false;
            }
         },

         expand_all(){
            for (let i=0; i<this.graders.length; i++){
               this.graders[i].expanded = true;
            }
         },

         async save_data(evt){

            this.saving_msg = 'Saving changes...';
            let post_data;
            // console.log(evt)

            let from_el = evt.from.id;
            let to_el = evt.to.id;
            let movededIx = evt.newIndex;

            // console.log(from_el, to_el);
            let to_name = to_el.split('--'); //assumes the id of grader list element is 'grader-ix--<i>'


            if (to_name[0] === 'grader-ix'){

               //get grader's list,
               let grader_ix = to_name[1];

               // get moved dealership
               let dealer = this.graders[grader_ix].dealerships[movededIx];
               dealer.grader_id = this.graders[grader_ix].user_id;

               post_data = {
                  _id: dealer._id,
                  grader_id: dealer.grader_id,
               };
            }

            // else set dealership as unassigned
            else {

               // get moved dealership
               let dealer = this.dealerships[movededIx];
               dealer.grader_id = null;

               post_data = {
                  _id: dealer._id,
                  grader_id: dealer.grader_id,
               };
            }

            // console.log(post_data)


            //save to db
            try {
               // console.log(post_data);
               let token = await this.$auth.getAxiosHeader();
               let url = this.$baseUrlApi + '/updateDealership';
               var res = await axios.post(url, post_data, token);

               this.saving_error_class = '';

               setTimeout(()=>{
                  this.saving_msg = 'Changes saved to db.';
               }, 500)


               setTimeout(()=>{
                  this.saving_msg = '';
               }, 5000)

            }
            catch(err){
               // eslint-disable-next-line
               this.show_error_details(err, 'save_data() ');
               this.saving_error_class = 'saving-msg-err';
               this.saving_msg = 'There was an issue saving.  Changes not saved!  Please refresh page and try again.';
            }
         },

      },
      created(){
         // this.get_dealers_local();
         // this.get_graders_local();
         this.update_data();
      }
   };
</script>

